import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Cookie from "js-cookie";
import {
  CloseCircleOutlined,
  CheckCircleOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
  CheckOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { Card, Input, Button, Alert } from "antd";
import MainLayout from "../../../components/layout";
import zxcvbn from "zxcvbn";

const checkPasswordStrength = (password) => {
  const result = zxcvbn(password);
  const score = result.score;
  const feedback = result.feedback.suggestions.join(" ");
  return { score, feedback };
};

const checkPasswordAgainstBreachDatabase = async (password) => {
  const sha1 = require("crypto").createHash("sha1");
  sha1.update(password);
  const hash = sha1.digest("hex").toUpperCase();
  const prefix = hash.substring(0, 5);
  const suffix = hash.substring(5);

  const response = await fetch(`https://api.pwnedpasswords.com/range/${prefix}`);
  const text = await response.text();
  const hashes = text.split("\n").map((line) => line.split(":")[0]);

  const isBreached = hashes.some((h) => h === suffix);
  return isBreached;
};

const SetPassword = (props) => {
  const { http } = global.services;
  const { token } = useParams();
  const [isLoading, setLoading] = useState(false);
  const [showErrorMessage, setshowErrorMessage] = useState("");
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [form, setForm] = useState({
    new_password: "",
    confirm_password: "",
    showNewPassword: false,
    showConfirmPassword: false,
    passStrength: 0,
    notEmail: true,
    length: false,
    specialChar: false,
    newPassError: "",
  });

  const newPasswordChange = (e) => {
    setshowErrorMessage("");
    const value = e.target.value;
    const temp = { ...form };
    const { score } = checkPasswordStrength(value);
    temp.new_password = value;
    temp.passStrength = score;
    temp.notEmail = !value.includes(Cookie.get("email"));
    temp.length = value.length >= 8;
    temp.specialChar = /[^a-zA-Z]/.test(value);
    setForm(temp);
  };

  const change = (props) => (e) => {
    let data = { ...form };
    data[props] = e.target.value;
    setForm(data);
  };

  const showPasswordHandler = (key) => {
    let data = { ...form };
    data[key] = !data[key];
    setForm(data);
  };

  const submit = async () => {
    if (isLoading) return;
    setForm({ ...form, newPassError: "" });
    if (form.passStrength < 3 || !form.notEmail || !form.length || !form.specialChar) {
      setshowErrorMessage("Please ensure your password meets the requirements");
      return;
    }

    if (!form.confirm_password) {
      setForm({
        ...form,
        newPassError: "Confirm password is required.",
      });
      return;
    }
    if (form.new_password !== form.confirm_password) {
      setForm({
        ...form,
        newPassError: "Confirm password did not match.",
      });
      return;
    }
    const isBreached = await checkPasswordAgainstBreachDatabase(form.new_password);
    if (isBreached) {
      setshowErrorMessage(
        "This password has been found in a database breach. Please choose another password",
      );
      return;
    }
    setLoading(true);
    try {
      let params = {
        new_password: form.new_password,
        confirm_password: form.confirm_password,
        type: "change",
      };

      let { data } = await http.put(`change-password`, params);
      setLoading(false);
      setShowSuccessMessage(true);
      Cookie.set("token_leads", data.token);
      Cookie.set("is_logged_once", JSON.parse(1));
      Cookie.set("email", data.email);

      setTimeout(() => {
        window.location.href = "/leads";
      }, 1000);
    } catch (err) {
      setLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      let is_logged_once = Cookie.get("is_logged_once");

      if (Cookie.get("token_leads")) {
        if (typeof is_logged_once === "undefined") {
          window.location.href = "/leads";
        }

        if (is_logged_once) {
          let firstTime = JSON.parse(is_logged_once);

          if (firstTime === 1) {
            window.location.href = "/leads";
          }
        }
      } else {
        window.location.href = "/";
      }
    })();

    return () => form;
  }, []);

  return (
    <React.Fragment>
      <MainLayout>
        <div className="flex justify-center items-center">
          <Card bordered={false}>
            <div className="flex-column items-center" style={{ padding: 40 }}>
              <strong>
                <h1 style={{ fontSize: 25, fontWeight: 550, marginBottom: 3 }}>
                  Change password
                </h1>
              </strong>
              <p
                style={{
                  opacity: 0.7,
                  marginBottom: 20,
                  width: 350,
                  textAlign: "center",
                }}
              >
                You’re signed in with a default password. Set a new one to continue.
              </p>

              {showSuccessMessage && (
                <>
                  <Alert
                    message="Password successully changed."
                    type="success"
                    style={{ width: "100%", textAlign: "center" }}
                  />
                  <br />
                </>
              )}
              {showErrorMessage && (
                <>
                  <Alert
                    message={showErrorMessage}
                    type="error"
                    style={{ width: "100%", textAlign: "center" }}
                  />
                  <br />
                </>
              )}
              <div className="flex flex-column flex-grow" style={{ width: 350 }}>
                <div className="flex justify-between">
                  <span>New Password</span>
                </div>
                <Input.Group compact>
                  <Input
                    value={form.new_password}
                    type={form.showNewPassword ? "text" : "password"}
                    className="inputs"
                    onChange={newPasswordChange}
                    suffix={
                      <>
                        {form.new_password.length === 0 ? (
                          <></>
                        ) : form.passStrength >= 3 ? (
                          <CheckCircleOutlined style={{ color: "rgb(37, 194, 129)" }} />
                        ) : (
                          <CloseCircleOutlined style={{ color: "rgb(239, 72, 54)" }} />
                        )}
                        <span
                          style={{ cursor: "pointer", fontSize: 16 }}
                          onClick={() => showPasswordHandler("showNewPassword")}
                        >
                          {form.showNewPassword ? (
                            <EyeInvisibleOutlined />
                          ) : (
                            <EyeOutlined />
                          )}
                        </span>
                      </>
                    }
                  />
                </Input.Group>
                <ul className="password-strength-box">
                  <li
                    style={{
                      color:
                        form.passStrength === 2
                          ? "rgb(246, 180, 77)"
                          : form.passStrength === 3
                            ? "rgb(8, 162, 98)"
                            : form.passStrength === 4
                              ? "rgb(8 162 98)"
                              : "rgb(239, 72, 54)",
                    }}
                  >
                    <span className="thumb">
                      {form.passStrength >= 3 ? <CheckOutlined /> : <CloseOutlined />}
                    </span>
                    Password strength:{" "}
                    {form.passStrength === 2
                      ? "Fair"
                      : form.passStrength === 3
                        ? "Good"
                        : form.passStrength === 4
                          ? "Strong"
                          : "Weak"}
                  </li>
                  <li
                    style={{
                      color: form.notEmail ? "rgb(8 162 98)" : "rgb(239, 72, 54)",
                    }}
                  >
                    <span className="thumb">
                      {form.notEmail ? <CheckOutlined /> : <CloseOutlined />}
                    </span>
                    Must not contain your email address
                  </li>
                  <li
                    style={{
                      color: form.length ? "rgb(8 162 98)" : "rgb(239, 72, 54)",
                    }}
                  >
                    <span className="thumb">
                      {form.length ? <CheckOutlined /> : <CloseOutlined />}
                    </span>
                    At least 8 characters
                  </li>
                  <li
                    style={{
                      color: form.specialChar ? "rgb(8 162 98)" : "rgb(239, 72, 54)",
                    }}
                  >
                    <span className="thumb">
                      {form.specialChar ? <CheckOutlined /> : <CloseOutlined />}
                    </span>
                    Must include a number or symbol
                  </li>
                </ul>
                <div>
                  <div className="flex justify-between">
                    <span>Confirm Password</span>
                  </div>
                  <Input.Group compact>
                    <Input
                      value={form.confirm_password}
                      type={form.showConfirmPassword ? "text" : "password"}
                      className="inputs"
                      onChange={change("confirm_password")}
                      suffix={
                        <span
                          style={{ cursor: "pointer", fontSize: 16 }}
                          onClick={() => showPasswordHandler("showConfirmPassword")}
                        >
                          {form.showConfirmPassword ? (
                            <EyeInvisibleOutlined />
                          ) : (
                            <EyeOutlined />
                          )}
                        </span>
                      }
                    />
                  </Input.Group>
                  {form.newPassError && (
                    <p style={{ color: "red", fontSize: 12, margin: 0 }}>
                      {form.newPassError}
                    </p>
                  )}
                </div>
                <Button
                  type="primary"
                  block
                  style={{
                    color: "#fff",
                    borderColor: "#c6b4f3",
                    backgroundColor: "#c6b4f3",
                    borderRadius: 8,
                    marginTop: 30,
                    height: 38,
                  }}
                  onClick={submit}
                  disabled={showSuccessMessage}
                >
                  Update Password
                </Button>
              </div>
            </div>
          </Card>
        </div>
      </MainLayout>
    </React.Fragment>
  );
};

export default SetPassword;
